import * as m from 'app/api/redux-jigsaw/jigsaw-methods';
import { createJigsawReaderAction } from 'app/api/redux-jigsaw/jigsaw-action';

export const updateNoteInternal = createJigsawReaderAction(m.UPDATE_NOTE);
export const getNotes = createJigsawReaderAction(m.GET_NOTES);
export const deleteNote = createJigsawReaderAction(m.DELETE_NOTE);
export const addNote = createJigsawReaderAction(m.ADD_NOTE);

export function updateNote(id, note) {
  return function(dispatch) {
    if (!note) {
      dispatch(deleteNote(id));
    } else {
      // While the api supports a string, object notation facilitates proper data updates in redux
      dispatch(updateNoteInternal(id, { note }));
    }
  };
}
